import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Experience } from "./components/Experience";
import { Projects } from "./components/Projects";
import { Stack } from "./components/Stack";
import { Services } from "./components/Services";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App">
      <NavBar />
      <main>
        <Banner />
        <Experience />
        <Projects />
        <Stack />
        <Services />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
